import axios from 'axios';
// import _ from 'lodash';
// Project imports
// import * as types from './actionTypes';
import * as urls from './urlTypes';

import {
  toastError,
} from '../util/toastUtils';


export const getRoleDetails = async roleId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/role/${roleId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get role details');
    return false;
  }
};

export const saveRole = async role => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/role`;
  let method = 'post';
  if (role.id) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/role/${role.id}`;
    method = 'put';
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
      data: role,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to save role');
    return false;
  }
};


export const deleteRole = async roleId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/role/${roleId}`;
  const method = 'delete';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    // console.warn(`Account Details call failed: ${error}`);
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to delete role.');
    return false;
  }
};


export const activeRole = async roleId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/role/${roleId}/activate`;
  const method = 'put';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to active role.');
    return false;
  }
};


export const getUserRoles = async userId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/user/${userId}/roles`;
  const method = 'get';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get user roles.');
    return false;
  }
};

export const getAccountPermissions = async (userId, accountId) => {
  const url = `${urls.API_GATEWAY_URL}/api/user-service/user/${userId}/account/${accountId}/permissions`;
  const method = 'get';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get user permissions');
    return false;
  }
};
